export default __webpack_public_path__ + "static/media/video-horizontal-background-0005.c5c66585.jpg";